<template>
  <div class="page">
    <m-header title="餐厅列表" subText=""/>
    <div class="page-content">
        <div class="splitBlock"></div>
        <div class="shopList" v-for="(item, index) in shopList" :key="index">
          <mt-field :label="item.restaurantName"  class="with-80 notRequired" disabled @click.native="nextHandle(item)">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-arrow-right"></use>
              </svg>
          </mt-field>                      
        </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    data () {
      return {
          
      }
    },
    async created() {
      console.log(this.requestShopList)
      if(this.requestShopList)return 
      this.setShopList([])
      const meiCanParams = this.meiCanParams
      const shopListParams = {
              targetTime: meiCanParams.targetTime,
              externalId: meiCanParams.externalId
      }
      await this.getMenuPromise(shopListParams)
    },
    computed: {
      ...mapGetters([
          'meiCanParams',
          'shopList',
          'requestShopList'
      ])
    },
    mounted() {
    },
    methods: {
      ...mapMutations([
        'setShopList',
        'setRequestShopList'
      ]),
      ...mapActions([
          'getMenuPromise'
      ]),
      nextHandle (item) {
        console.log(item)
        this.$router.push({ path: '/takeOutShopDetail' ,query:{restaurantId:item.restaurantId}})
      }
    },
    beforeRouteLeave(to, from, next) {
      let path = to.path
      if(path == '/takeOutShopDetail') {
        this.setRequestShopList(true)
      }
      if(path == '/') {
        this.setRequestShopList(false)
      }
      next()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/takeOutShopList.vue